import {injectable} from "inversify";
import {Player} from "@/modules/team/entity";
import {roundFront} from "@/modules/base/services/chance";
import {YouthPlayer} from "@/modules/youth/entity";

@injectable()
export default class MarketValueCalculator {
  public async calculate(player: Player | YouthPlayer): Promise<number> {
    return roundFront(player.skill * 100);
  }
}
